<template lang="pug">
v-container(fluid pa-0 ma-0)
  div(class=" tw-bg-white tw-rounded-md py-4 px-2 ")
    v-spacer
    v-row(no-gutters align="center")
      v-col(cols="auto" class="pl-2")
        v-row(no-gutters)
          v-col(cols="auto")
        span(class="tw-font-bold tw-text-xl") {{ status === 'ready' ? stats.total : '—' }}
            v-icon(v-if="status === 'error'" small color="error" :aria-label="$t('Common.emptyStates.statsError')") mdi-alert-circle-outline
            template(v-if="status === 'ready' && stats.total > 0")
              v-icon(v-if="stats.trend >= 1" small color=" green lighten-2 " class="pb-2") mdi-arrow-up
              v-icon(v-if="stats.trend < 1" small color=" red lighten-2 " class="pb-2") mdi-arrow-down
            template(v-else-if="status === 'ready'")
              v-icon(small color=" white " class="pb-2") mdi-arrow-up
        v-row(no-gutters)
          v-col(cols="auto" class="tw--mt-1")
            span(class=" tw-text-sm") {{ $t('Common.leads') }}
      v-spacer
      v-col(cols="")
        v-sparkline(
          v-if="status === 'ready' && stats.timeline_values.length > 0"
          color="green accent-3"
          smooth="15"
          auto-draw
          line-width="2"
          :fill=false
          :value="stats.timeline_values"
        )
</template>

<script>
export default {
  data() {
    return { status: 'loading' };
  },
  computed: {
    stats() {
      const stats = this.$store.getters['team/statsLeads'] || {};
      return {
        total: Number(stats.total) || 0,
        trend: Number(stats.trend) || 0,
        timeline_values: Array.isArray(stats.timeline_values) ? stats.timeline_values : [],
      };
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('team/getStatsLeads');
      this.status = 'ready';
    } catch (error) {
      this.status = 'error';
    }
  },
};
</script>
